<template>
  <div class="next" @click="next_click()">
    <div class="next_top"><span>next<i class="fas fa-chevron-right i-arrow"></i></span></div>
    <div class="next_bottom">
      <slot></slot>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Next',
  components: {
    
  },
  props: {
    href: ''
  },
  methods: {
    next_click(){
      let vm = this
      vm.$router.push(vm.href)
      window.scrollTo(0, 0)
      if(this.$router.history.current.path == '/damaged_building'){
        ga('newmedia.send', {
          hitType: 'event',
          eventCategory: 'next button',
          eventAction: 'Click',
          eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [button 1]`,
        })
      }
      if(this.$router.history.current.path == '/earthquake_resistance'){
        ga('newmedia.send', {
          hitType: 'event',
          eventCategory: 'next button',
          eventAction: 'Click',
          eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [button 2]`,
        })
      }
    },
    detectPlatform() {
      if( navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
      ){
          return 'Mob';
      }
      else {
          return 'PC';
      }
    }
  },
  computed: {
  },
  created() {

  },
  mounted() {
  }
}
</script>

<style lang="sass" scoped>
.next
  width: 100%
  background: #f1f1f1
  padding: 2rem 4rem
  text-align: center
  cursor: pointer
  @media (min-width: 768px)
    padding: 3rem 4rem
  .next_top
    padding-bottom: 2rem
    span
      position: relative
      font-size: 1.8rem
      line-height: 1.2
      @media (min-width: 768px)
        font-size: 2.2rem
  .next_bottom
    display: flex
    text-align: center
    justify-content: center
    span
      font-weight: bold
      font-size: 1.8rem
      line-height: 1.2
      @media (min-width: 768px)
        font-size: 2.2rem
.i-arrow
  position: absolute
  top: 50%
  right: 0
  transform: translate(40px,-50%)
  font-size: 1.8rem
  line-height: 1.2
  @media (min-width: 768px)
    transform: translate(50px,-50%)
    font-size: 2rem

</style>
